import { Stack, Tooltip } from '@mui/joy';
import React from 'react';
import StackedLinearProgressComponent from './StackedLinearProgressComponent';

function IssueOverallSentimentBar({ reviews }: any) {
    const badReviews = reviews.filter((d: any) => d.sentiment === 'bad');
    const goodReviews = reviews.filter((d: any) => d.sentiment === 'good');
    const neutralReviews = reviews.filter((d: any) => d.sentiment === 'neutral');

    const total = reviews.length;

    const badWidth = (badReviews.length / total) * 100;
    const goodWidth = (goodReviews.length / total) * 100;
    const neutralWidth = (neutralReviews.length / total) * 100;

    return (
        <Stack spacing={0}>
            <Tooltip
                title='Bad sentiment percentage'
                size='sm'
                placement='top'>
                <StackedLinearProgressComponent
                    segments={[
                        { label: 'Positive', value: goodWidth, color: '#22c55e' },
                        { label: 'Neutral', value: neutralWidth, color: '#eab308' },
                        { label: 'Negative', value: badWidth, color: '#ef4444' }
                    ]}
                    height="6px"
                    width="90px"
                    showTooltip={true}
                />
            </Tooltip>
        </Stack>
    );
}

export default IssueOverallSentimentBar;